import React from 'react';
import { LEGAL_REVISION, LEGAL_UPDATED_AT } from '../content/legalDocuments';
import '../styles/legal.css';

export default function LegalDocumentContent({ legalDocument, headingLevel = 'h3' }) {
  const Heading = headingLevel;

  return (
    <div className="legal-document" lang="ru">
      <p className="legal-document__revision">
        Редакция от <time dateTime={LEGAL_REVISION}>{LEGAL_UPDATED_AT}</time>
      </p>
      {legalDocument.sections.map((section) => (
        <section key={section.title} className="legal-document__section">
          <Heading>{section.title}</Heading>
          {section.paragraphs?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.items && (
            <ul>{section.items.map((item) => <li key={item}>{item}</li>)}</ul>
          )}
          {section.after?.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
          {section.links && (
            <ul className="legal-document__links">
              {section.links.map(({ href, label }) => (
                <li key={href}>
                  <a href={href} target="_blank" rel="noopener noreferrer">{label}</a>
                </li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}
